import { instance } from "@/lib/hooks";
import { createAxiosQuery } from "@/hooks/react-query";
import { OrganizationHierarchyResponse } from "@/pages/CMWFeatureFlags/types";

export const useCMWFeatureFlagHierarchyQuery = createAxiosQuery(
  "cmw-feature-flags-organization-hierarchy",
  async () => {
    return instance.get<OrganizationHierarchyResponse>(
      "/cmw-feature-flags/organization-hierarchy"
    );
  }
);
